import React, { FC, Fragment, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu as MuiMenu, MenuItem } from '@mui/material';
import MoreHorzIcon from '@mui/icons-material/MoreHoriz';

interface Props {
  sort: boolean;
  onSort: () => void;
}

const FeedMenu: FC<Props> = ({ sort, onSort }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  function handleClick(event: MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleSort() {
    handleClose();
    onSort();
  }

  return (
    <Fragment>
      <IconButton
        onClick={handleClick}
        size="large"
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <MoreHorzIcon />
      </IconButton>
      <MuiMenu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        <MenuItem selected={sort} disabled={sort} onClick={handleSort}>
          {t('feed:menuTrending')}
        </MenuItem>
        <MenuItem selected={!sort} disabled={!sort} onClick={handleSort}>
          {t('feed:menuChronologically')}
        </MenuItem>
      </MuiMenu>
    </Fragment>
  );
};

export default FeedMenu;
